export const isSmartChargingProUser = () => {
  const user = JSON.parse(localStorage.getItem('auth-user'));

  return !!user?.permissions.some(
    (permission) =>
      permission.role_id === 'DASH_CVE_PRO_SMART_CHARGING_LOAD_BALANCE' &&
      !!permission.status,
  );
};
